import { render, staticRenderFns } from "./CreateAiBusinessPromoter.vue?vue&type=template&id=c842981c&scoped=true&"
import script from "./CreateAiBusinessPromoter.vue?vue&type=script&lang=js&"
export * from "./CreateAiBusinessPromoter.vue?vue&type=script&lang=js&"
import style0 from "./CreateAiBusinessPromoter.vue?vue&type=style&index=0&id=c842981c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c842981c",
  null
  
)

export default component.exports